import { Outlet, useNavigate } from "react-router-dom";
import { AppShell, Burger } from "@mantine/core";
import { useDisclosure } from "@mantine/hooks";
import { Navbar } from "./Navbar";
import { navbarPrimary, navbarFooter } from "../utils/consts";
import { AppHeader } from "./AppSkeleton/AppHeader";
import { useAuth } from "../hooks/useAuth";
import { defaultHomePath } from "../utils/navigationScopes";
import { useEffect, useRef } from "react";
import { useOrganizationQuery } from "../api/queries";
import { toast } from "sonner";
import { useMailboxSyncStatusMonitor } from "../hooks/useMailboxSyncStatus";
import { AccountingRefreshProvider } from "../context/AccountingRefreshContext";

export default function AppSkeleton() {
  const [mobileMenuOpened, { toggle: toggleMobileMenu, close: closeMobileMenu }] =
    useDisclosure(false);
  const navigate = useNavigate();
  const { logout, scopes } = useAuth();
  const { data: organization } = useOrganizationQuery();
  const hasShownToastRef = useRef(false);

  // Monitor mailbox sync status and show error toasts
  useMailboxSyncStatusMonitor();

  const handleNavigateHome = () => navigate(defaultHomePath(scopes));
  const handleLogout = () => logout();

  useEffect(() => {
    if (
      organization &&
      organization.accounting_software === null &&
      !hasShownToastRef.current
    ) {
      toast.warning(
        "Please connect your accounting software under Files & Integrations",
      );
      hasShownToastRef.current = true;
    }
  }, [organization]);

  return (
    <AppShell
      navbar={{
        width: 96,
        breakpoint: "sm",
        collapsed: { mobile: !mobileMenuOpened },
      }}
      header={{ height: 60 }}
      className="h-screen"
    >
      <AppShell.Header>
        <div className="md:hidden">
          <Burger
            opened={mobileMenuOpened}
            onClick={toggleMobileMenu}
            size="sm"
            className="absolute left-4 top-4 z-10"
          />
        </div>
        <AppHeader
          onLogoutClick={handleLogout}
          onNavigateHome={handleNavigateHome}
        />
      </AppShell.Header>

      <AppShell.Navbar>
        <div className="flex h-full min-h-0 flex-col items-center justify-start pt-4">
          <Navbar
            primary={navbarPrimary}
            footer={navbarFooter}
            onNavigate={closeMobileMenu}
          />
        </div>
      </AppShell.Navbar>

      <AppShell.Main className="h-screen overflow-auto">
        <div className="mx-auto flex h-full min-h-0 w-full max-w-none flex-col items-center px-4 py-6 md:px-8">
          <AccountingRefreshProvider>
            <Outlet />
          </AccountingRefreshProvider>
        </div>
      </AppShell.Main>
    </AppShell>
  );
}
